import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress DOMException from react-error-overlay trying to postMessage
// non-cloneable fetch Request/Response objects. This is a known CRA dev-mode
// issue that does not affect actual app functionality.
window.addEventListener("error", (event) => {
  if (
    event.message &&
    event.message.includes("postMessage") &&
    event.message.includes("could not be cloned")
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (event) => {
  const msg =
    event.reason && event.reason.message ? event.reason.message : String(event.reason || "");
  if (msg.includes("postMessage") && msg.includes("could not be cloned")) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
